export const decimalSeparator = () => {
  const n = 1.1;
  const dec = n.toLocaleString().substring(1, 2);
  return dec;
};
